import React, {useState} from "react";
import cx from "classnames";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from "react-bootstrap/Accordion";

import ButtonPrimary from "../../../components/button-primary/ButtonPrimary";

import styles from './FAQ.module.scss';

type QuestionHeaderProps = {
    children: React.ReactNode;
};

type FAQProps = {
    handleOpen: () => void;
};

function QuestionHeader({ children }: QuestionHeaderProps) {

    const [isOpen, setIsOpen] = useState(false);

    return (
        <Accordion.Header className={cx(styles.header, {
            [styles.headerOpened]: isOpen,
        })} onClick={() => setIsOpen(!isOpen)}>
            <span className={styles.headerText}>{children}</span>
            <span className={cx(styles.buttonContainer, styles.header,
                {
                    [styles.headerOpened]: isOpen,
                })}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.82 31.4099L24 22.2499L33.18 31.4099L36 28.5899L24 16.5899L12 28.5899L14.82 31.4099Z" fill="currentColor"/>
                </svg>
            </span>
        </Accordion.Header>
    );
}


function FAQ({handleOpen}: FAQProps) {

    const questions = [
        {
            question: 'Когда я смогу начать использовать калькулятор?',
            answer: <>Тестовая версия калькулятора будет доступна в&nbsp;ближайшее время. <br/>
                Вы&nbsp;можете <span onClick={handleOpen} className={styles.link}>оставить заявку</span> на&nbsp;сайте &nbsp;&mdash; как только мы&nbsp;откроем тестирование, вы&nbsp;получите уведомление и&nbsp;сможете воспользоваться калькулятором в&nbsp;числе первых.</>,
        },
        {
            question: 'Учтены ли все дополнительные расходы на доставку?',
            answer: <>Помимо транспортных расходов, Вэдмаркет учитывает информацию о&nbsp;ТН&nbsp;ВЭД коде, нетарифное регулирование, страхование груза и&nbsp;другие обязательные платежи. Вэдмаркет собирает эти данные от&nbsp;партнеров в&nbsp;режиме реального времени и&nbsp;рассчитывает итоговую стоимость с&nbsp;точностью до&nbsp;99%.</>,
        },
        {
            question: 'Насколько точен калькулятор стоимости доставки и растаможки?',
            answer: <>Калькулятор показывает высокую точность до&nbsp;99% при расчете поставки на&nbsp;основании инвойса и&nbsp;упаковочного листа. Для предварительного расчета без этих документов точность расчета может быть ниже.</>,
        },
        {
            question: 'Как посчитать стоимость растаможки в России?',
            answer: <>Вэдмаркет позволяет рассчитать все пошлины, НДС и&nbsp;сборы с&nbsp;точностью до&nbsp;99%, собирая данные в&nbsp;реальном времени у&nbsp;компаний партнеров. Подходит для любого типа товаров для импорта в&nbsp;РФ.</>,
        },
        {
            question: 'Что входит в таможенные пошлины и сборы?',
            answer: <>Основные расходы&nbsp;&mdash; НДС, пошлины (акциз) и&nbsp;таможенный сбор. Вэдмаркет учитывает необходимую информацию после ввода данных о&nbsp;поставке и&nbsp;кода ТН&nbsp;ВЭД и&nbsp;показывает размер таможенных платежей, включая пошлины, НДС, сборы, услуги таможенного брокера и&nbsp;итоговую стоимость оформления.</>,
        },
        {
            question: 'Можно ли посчитать логистику из Китая?',
            answer: <>Вэдмаркет позволяет рассчитать стоимость поставки груза из&nbsp;Китая. Вы&nbsp;получите предварительный расчет после заполнении информации о&nbsp;товарах, параметрах груза и&nbsp;стране отправления. Калькулятор сделает расчёт маршрута, сроков и&nbsp;стоимости доставки.</>,
        },
        {
            question: 'Работает ли калькулятор для импорта в Россию?',
            answer: <>Да, Вэдмаркет разработан для работы с&nbsp;внешнеэкономической деятельностью, в&nbsp;том числе с&nbsp;Россией. Расчёты адаптированы под местные требования.</>,
        },
        {
            question: 'Как получить номер для отслеживания контейнера?',
            answer: <>Номер отслеживания (трек-номер) становится доступен после подтверждения отгрузки от&nbsp;логистической компании.</>,
        },
        {
            question: 'Вы ищете партнёров среди экспедиторских компаний?',
            answer: <>Да, мы&nbsp;открыты к&nbsp;сотрудничеству с&nbsp;логистическими и&nbsp;экспедиторскими компаниями. Пишите на&nbsp;<a href="mailto:demo@vedmarket.ru">demo@vedmarket.ru</a>.</>,
        },
    ]

    return (
        <div className={styles.faq} id='faq'>
            <Container className={styles.faqContainer}>
                <Row>
                    <Col xs={12}>
                        <h1 className={styles.title}>Вопросы-ответы</h1>
                        <ButtonPrimary onClick={handleOpen} className={styles.primaryButton}>
                            <>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z" fill="currentColor"/>
                                </svg>
                                Задать вопрос
                                </>
                        </ButtonPrimary>
                    </Col>
                </Row>
                <div className={styles.questions}>
                        {questions.map((question, index) => (
                            <Accordion key={index}>
                            <Row>
                                <Col xl={8}>
                                    <Accordion.Item className={styles.accordion} eventKey={String(index)}>
                                        <QuestionHeader>{question.question}</QuestionHeader>
                                        <Accordion.Body className={styles.accordionBody}>
                                            {question.answer}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Col>
                            </Row>
                            </Accordion>
                        ))}
                </div>
            </Container>
        </div>
    );
}

export default FAQ;
